goog.provide("shadow.js.shim.module$$mui$material$ListItemAvatar");
goog.provide("module$shadow_js_shim_module$$mui$material$ListItemAvatar");
shadow.js.shim.module$$mui$material$ListItemAvatar = shadow.js.nativeProvides["@mui/material/ListItemAvatar"] = shadow$bridge("@mui/material/ListItemAvatar");
module$shadow_js_shim_module$$mui$material$ListItemAvatar.default = shadow.js.shim.module$$mui$material$ListItemAvatar;
